<div class="h-[calc(100vh-8rem)] overflow-hidden" [formGroup]="sortimentForm">
  <aw-section
    class="block h-full [&>div]:h-full [&>div]:overflow-hidden"
    testIdAffix="sortiment">
    <aw-section-header>
      <aw-section-headline>
        {{ cmsTextProvider.sortiment.headline }}
      </aw-section-headline>
      <aw-section-header-actions>
        <aw-button
          [id]="'corporate-cancel'"
          [type]="'button'"
          [style]="'primary-alt'"
          [isDisabled]="!hasChanges() || cmsTicketOverviewService.hasError()"
          (click)="handleAbortChangesDialog()"
          [text]="cmsTextProvider.shared.cancel">
        </aw-button>
        <aw-button
          [id]="'corporate-save'"
          [isDisabled]="!hasChanges() || cmsTicketOverviewService.hasError()"
          [type]="'submit'"
          [style]="'primary'"
          (click)="save()"
          [text]="cmsTextProvider.shared.save"></aw-button>
      </aw-section-header-actions>
    </aw-section-header>

    <aw-section
      class="block min-h-0 flex-1 [&>div]:h-full [&>div]:overflow-hidden"
      testIdAffix="sortiment-search">
      <div class="sortiment-columns grid min-h-0 flex-1 gap-4 overflow-hidden">
        <aside class="min-h-0 overflow-hidden">
          <aw-sortiment-section
            class="block h-full min-h-0"
            [tickets]="cmsTicketOverviewService.tickets()"
            [isLoading]="cmsTicketOverviewService.isLoading()"
            [hasError]="cmsTicketOverviewService.hasError()"
            (retry)="cmsTicketOverviewService.reloadTickets()"
            [selectedTicketId]="selectedTicketId()"
            (ticketSelected)="selectedTicketId.set($event)"
            [editedTicketIds]="editedTicketIds()"
            [completedLayoutTicketIds]="completedLayoutTicketIds()" />
        </aside>
        @for (
          ticketForm of [selectedTicketForm() ?? placeholderTicketForm];
          track selectedTicketId()
        ) {
          <main
            class="min-h-0 overflow-hidden pr-2"
            [attr.inert]="!selectedTicketForm() ? '' : null">
            <aw-sortiment-edit
              class="block h-full min-h-0"
              [ticketForm]="ticketForm"
              [selectedTicket]="
                selectedTicketForm() ? selectedTicket() : undefined
              "
              [isTicketLayoutCompleted]="
                completedLayoutTicketIds().has(selectedTicketId() ?? '')
              "
              [sortimentForm]="sortimentForm"
              (resetTicket)="resetSelectedTicket()"
              [unassignedLayoutTicketCount]="unassignedLayoutCount()" />
          </main>
          <aside
            class="bg-standard-surface border-l-standard-outline-light min-h-0 overflow-hidden border-l">
            <aw-sortiment-preview
              class="block"
              [ticketForm]="ticketForm"
              [ticketName]="
                selectedTicket()?.name ??
                cmsTextProvider.sortiment.defaultProductName
              "
              [isRelationTicket]="selectedTicket()?.ticketType === 'Relation'"
              [buttonTextControl]="sortimentForm.controls.buttonText" />
          </aside>
        }
      </div>
    </aw-section>
  </aw-section>
</div>
